import {MdOutlineMoreHoriz} from "react-icons/md"
import styled from "styled-components"
import formatConverter from "../../../../helper/formatConverter"
import { getShipmentRouteBounds, normalizeShipmentListItem } from "../../../../helper/shipment/safeShipmentListItem"
import { Link, useNavigate } from "react-router-dom"
import { useDispatch } from "react-redux"
import { useEffect } from "react"
import { setLoadItemData } from "../../../../features/loadList/loadListSlice"
import { useRef } from "react"
import moment from "moment/moment"
import yayinlamaSecenekleriOptions from "../../../../utils/yukOptions/yayinlamaSecenekleriOptions"
import arrow from "../../../../images/svg/load-arrow.svg"

const Container = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    margin-bottom: 30px;
    color: ${({theme}) => theme.mainTextColor};

    .content-container{
        width: 100%;
        display: grid;
        grid-template-columns: 1fr 1fr 1fr;
        align-items: center;
        border-radius: 10px;
        gap: 5px;
        padding: 8px 10px;
        cursor: pointer;
        border: 2px solid ;
        border-color:  ${({ theme }) => theme.mainBorderColor};
        .content-item{
            font-size: 12px;
            font-weight: var(--font-weight-md);
            text-align: center;
        }
        .line-container{
            display: flex;
            align-items: center;
            
            .line{
                width: 100%;
                border-bottom: 1px solid black;
                margin-top: 3px;
            }
        }
        
    }

    .title{
        font-size: 14px !important;
        font-weight: var(--font-weight-lg) !important;
    }
    
`

const ItemMobileContainer = ({item: sourceItem, activeItemId, handleClick}) => {
    const item = normalizeShipmentListItem(sourceItem)
    const {firstRoutePoint, lastRoutePoint} = getShipmentRouteBounds(item.routePoints)
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const storage = JSON.parse(localStorage.getItem("isRemember")) ? localStorage : sessionStorage;

    useEffect(() => {
        if(activeItemId === item.id){
            handleClick(item.id)
        }
    },[activeItemId])

  return (
    <Container onClick={() => {dispatch(setLoadItemData(item)); navigate("/yuk-detay")}}>

       <div className="content-container">
            <div className="left-side">
                <div className="content-item title">{firstRoutePoint.displayName}</div>
            </div>

            <div className="mid">
                <div className="content-item">{formatConverter(item.distance, 0)} Km</div>
                <div className="line-container">
                    <div className="top"><img src={arrow} alt="" /></div>
                    <div className="line" />
                    <div className="top"><img src={arrow} alt="" /></div>
                </div>
                {item.LoadUnitId === 3 ? (
                    <div className="content-item">
                    Basar Tonaj{" "}
                    {item.loadBulk > 0 &&
                        ` - ${item.loadBulk} ${item.loadBulk > 0 && "m3"}`}
                    </div>
                ) : (
                    <div className="content-item">
                    {item.loadQuantity} {item.loadUnit}{" "}
                    {item.loadBulk > 0 &&
                        ` - ${item.loadBulk} ${item.loadBulk > 0 && "m3"}`}
                    </div>
                )}
                <div className="content-item">
                    {item?.truckType}
                </div>
                {/* <div className="content-item">
                    <img src="" alt="" />
                </div> */}
            </div>

            <div className="right-side">
                <div className="content-item title">{lastRoutePoint.displayName}</div>
            </div>
       </div>


    </Container>
  )
}

export default ItemMobileContainer
